// @ts-nocheck
import { DECLINED_BETS_HISTORY_DATA_CHANGED, DECLINED_BETS_HISTORY_DATA_CLEARED } from '../types';

const initialState = {
    declinedBetsHistoryList: [],
};

const onlineReports = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case DECLINED_BETS_HISTORY_DATA_CHANGED: {
            return {
                ...state,
                declinedBetsHistoryList: payload,
            };
        }
        case DECLINED_BETS_HISTORY_DATA_CLEARED: {
            return {
                ...state,
                declinedBetsHistoryList: initialState.declinedBetsHistoryList,
            };
        }

        default: {
            return state;
        }
    }
};

export default onlineReports;
